import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

import { ApiQuestion } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

export interface QuestionSortDialogData {
  questions?: ApiQuestion[];
}

@Component({
  selector: 'app-question-sort-dialog',
  templateUrl: './question-sort-dialog.component.html',
  styleUrls: ['./question-sort-dialog.component.css'],
  standalone: false,
})
export class QuestionSortDialogComponent implements OnInit {

  //建物情報
  questions!: Array<ApiQuestion>;
  isAdded: boolean = false;
  projectLanguages!: Array<ProjectLanguage>;

  questionTypes = AppConst.QUESTION_ITEM_TYPES;

  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<QuestionSortDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QuestionSortDialogData,
    public dialog: MatDialog,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.questions = this.data.questions!;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
  }

  ngAfterViewInit(): void {
  }

  //更新ボタン
  addQuestion(): void {
    let display_no = 0;
    for (const question of this.questions) {
      display_no = display_no + 1;
      question.display_no = display_no;
    }
    this.dialogRef.close(this.questions);
  }

  //取消ボタン
  onNoClick(): void {
    this.dialogRef.close();
  }

  //選択肢並べ替え
  onDropSelectItem(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.questions, event.previousIndex, event.currentIndex);
  }

}
